// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Pagination } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/pagination";

// init Swiper:
const swiper = new Swiper(".hero-slider-block .swiper", {
  modules: [Pagination],
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    speed: 800,
  },
});
